import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const DebouncedInput = ({ state, setState, label, name }) => {
  const [inputValue, setInputValue] = useState(state ?? "");
  const { t } = useTranslation();
  const didMountRef = useRef(false);

  // keep local input in sync if parent resets/changes it
  useEffect(() => {
    setInputValue(state ?? "");
  }, [state]);

  useEffect(() => {
    // skip first run (mount)
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const handler = setTimeout(() => {
      setState(name, inputValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [inputValue, name, setState]);

  return (
    <input
      type="text"
      className="text-input-sm"
      value={inputValue}
      name={label}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={t(`yard-tables.table-columns.${label}`)}
    />
  );
};

export default DebouncedInput;